// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.react-modal-overlay.report-problem-modal .react-modal {
  /*border: 0.1rem solid #000;*/
  color: #fff;
}
@media (min-width: 425px) {
  .react-modal-overlay.report-problem-modal .react-modal {
    padding: 2rem;
    top: 10%;
    left: 0;
    right: 0;
    bottom: 10%;
  }
}
@media (min-width: 1281px) {
  .react-modal-overlay.report-problem-modal .react-modal {
    padding: 0;
    top: 20%;
    left: 25%;
    right: 25%;
    bottom: 20%;
  }
}

.report-problem legend {
  font-size: 1.4rem;
  color: white;
  border: none;
}
.report-problem .react-select {
  margin: 0 0.1rem 1rem;
}

.report-problem-modal .my-account-header {
  text-transform: uppercase;
}
.report-problem-modal .my-account-content a.faq,
.report-problem-modal .my-account-content a.report,
.report-problem-modal .my-account-content a.terms,
.report-problem-modal .my-account-content a.privacy,
.report-problem-modal .my-account-content .referrals-link {
  line-height: 2.5rem;
  color: white;
  display: block;
  text-transform: uppercase;
  cursor: pointer;
}
.report-problem-modal .my-account-content a.faq:hover,
.report-problem-modal .my-account-content a.report:hover,
.report-problem-modal .my-account-content a.terms:hover,
.report-problem-modal .my-account-content a.privacy:hover,
.report-problem-modal .my-account-content .referrals-link:hover {
  text-decoration: underline;
}
.report-problem-modal .report-problem a.back-btn {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Pages/Account/ReportProblemModal.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AACE;EACE,6BAAA;EACA,WAAA;AAEJ;AADI;EAHF;IAII,aAAA;IACA,QAAA;IACA,OAAA;IACA,QAAA;IACA,WAAA;EAIJ;AACF;AAHI;EAVF;IAWI,UAAA;IACA,QAAA;IACA,SAAA;IACA,UAAA;IACA,WAAA;EAMJ;AACF;;AADE;EACE,iBAAA;EACA,YAAA;EACA,YAAA;AAIJ;AADE;EACE,qBAAA;AAGJ;;AAEE;EACE,yBAAA;AACJ;AAGI;;;;;EAKE,mBAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;AADN;AAGM;;;;;EACE,0BAAA;AAGR;AAEE;EACE,aAAA;AAAJ","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import './Variables.scss';\n@import './Colors.scss';\n.react-modal-overlay.report-problem-modal {\n  .react-modal {\n    /*border: 0.1rem solid #000;*/\n    color: #fff;\n    @media (min-width: $smobile) {\n      padding: 2rem;\n      top: 10%;\n      left: 0;\n      right: 0;\n      bottom: 10%;\n    }\n    @media (min-width: $hdlaptop) {\n      padding: 0;\n      top: 20%;\n      left: 25%;\n      right: 25%;\n      bottom: 20%;\n    }\n  }\n}\n\n.report-problem {\n  legend {\n    font-size: 1.4rem;\n    color: white;\n    border: none;\n  }\n\n  .react-select {\n    margin: 0 0.1rem 1rem;\n  }\n}\n\n.report-problem-modal {\n  .my-account-header {\n    text-transform: uppercase;\n  }\n\n  .my-account-content {\n    a.faq,\n    a.report,\n    a.terms,\n    a.privacy,\n    .referrals-link {\n      line-height: 2.5rem;\n      color: white;\n      display: block;\n      text-transform: uppercase;\n      cursor: pointer;\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n  }\n\n  .report-problem a.back-btn {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
